exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-login-js": () => import("./../../../src/pages/login.js" /* webpackChunkName: "component---src-pages-login-js" */),
  "component---src-pages-manage-resort-js": () => import("./../../../src/pages/manage-resort.js" /* webpackChunkName: "component---src-pages-manage-resort-js" */),
  "component---src-pages-webform-js": () => import("./../../../src/pages/webform.js" /* webpackChunkName: "component---src-pages-webform-js" */)
}

